import { render } from "./PSearch.vue?vue&type=template&id=1094f71f"
import script from "./PSearch.vue?vue&type=script&lang=js"
export * from "./PSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__